import { useEffect, useState } from 'react';

import { useSelectedProjectId } from 'features/projects';
import { UsersView } from 'features/users';
import BulkUserImportWizard from 'features/users/components/BulkUserImportWizard';

import { Button } from '@/components/ui/button';

const UsersPage = () => {
  const selectedProjectId = useSelectedProjectId();
  const [bulkOpen, setBulkOpen] = useState(false);

  useEffect(() => {
    if (selectedProjectId === null && bulkOpen) {
      setBulkOpen(false);
    }
  }, [selectedProjectId, bulkOpen]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <header>
          <p className="text-xs font-bold uppercase tracking-widest text-text-subtle mb-1 font-body">Configuración</p>
          <h2 className="text-2xl font-bold text-text-default m-0 font-display">Usuarios</h2>
        </header>
        {selectedProjectId !== null && (
          <Button type="button" variant="outline" onClick={() => setBulkOpen((v) => !v)}>
            Carga masiva de usuarios
          </Button>
        )}
      </div>
      {bulkOpen && selectedProjectId !== null && (
        <BulkUserImportWizard
          projectId={selectedProjectId}
          onFinished={() => {
            setBulkOpen(false);
          }}
        />
      )}
      <UsersView omitHeader />
    </div>
  );
};

export default UsersPage;
